export interface ImagePreviewData {
  imagesMedia: any[];
  selectedImageId: number;
  title: string;
  disableBGCoverImage?: boolean;
}

export enum MediaType {
  Image = 'image',
  Video = 'video',
}
